export interface SampleReceptionDetailsDto {
  barcode?: string;
  sampleNameCustomer?: string;
  orderComment?: string;
  sampleSource?: string;
  libraryType?: string;
  orderNumber?: string;
  customerName?: string;
  orderSampleCount?: number;
  containerSampleCount?: number;
  gxp?: boolean;
  extraction: boolean;
  receptionDetails?: ReceptionDetails;
  sampleShortCode?: string;
  sampleName?: string;
  unreceivedSamplesCount?: number
  cancellationRequested: boolean;
  plateBarcode?: string;
  platePosition?: string;
  plateUnreceivedSampleCount?: number;
}

export interface ReceptionDetails {
  sampleStatus?: SampleReceptionStatus;
  sampleIssueComment? : string;
  userId?: string;
  arrivalTemp?: string;
  storageTemp?: string;
  storageLocation?: string;
  nextStep?: string;
  receptionComment?: string;
  orderIssues?: string[];
  rgcAvailable?: boolean;
  arrivalDate?: Date;
}

export enum SampleReceptionStatus {
  RECEIVED = 'RECEIVED',
  DESTROYED = 'DESTROYED',
  EMPTY = 'EMPTY',
  BARCODE_LOOSE = 'BARCODE_LOOSE',
  MINOR_ISSUE = 'MINOR_ISSUE'
}
